import { useEffect } from "react";

const BookJavits3 = () => {
  useEffect(() => {
    const metaNoIndex = document.createElement("meta");
    metaNoIndex.name = "robots";
    metaNoIndex.content = "noindex, nofollow";
    document.head.appendChild(metaNoIndex);
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black overflow-hidden">
      <iframe
        src="https://quietcove.wiseingress.com/#/quietcove;uid=b9af780a-cbdc-43be-a897-a774511d1cf2;source=iframe"
        className="w-full h-full border-0"
        style={{ minWidth: '100vw', minHeight: '100vh' }}
        allow="payment *; clipboard-read; clipboard-write"
        loading="eager"
        referrerPolicy="no-referrer-when-downgrade"
        title="Quiet Corner Booking Kiosk - Javits 3"
      />
    </div>
  );
};

export default BookJavits3;
